import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";

interface Candidate {
  path: string;
  looksLikeProject: boolean;
  looksLikeTranslation: boolean;
}

export function ProjectAdd() {
  const navigate = useNavigate();
  const [repoUrl, setRepoUrl] = useState("");
  const [branch, setBranch] = useState("main");
  const [candidates, setCandidates] = useState<Candidate[] | null>(null);
  const [selectedPath, setSelectedPath] = useState<string | null>(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleDiscover(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const result = await api.discoverProject(repoUrl, branch);
      setCandidates(result.candidates);
      const bestGuess = result.candidates.find((c) => c.looksLikeProject);
      if (bestGuess) setSelectedPath(bestGuess.path);
      if (!name) setName(repoUrl.split("/").filter(Boolean).pop() ?? "");
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleConfirm(e: React.FormEvent) {
    e.preventDefault();
    if (!selectedPath) return;
    setLoading(true);
    setError(null);
    try {
      const { id } = await api.addProject({
        repoUrl,
        branch,
        jsonPath: selectedPath,
        name,
        description: description || undefined,
      });
      navigate(`/projects/${id}`);
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page page--narrow">
      <h1>Ajouter un projet Shoggoth</h1>

      <form onSubmit={handleDiscover} className="form">
        <label>
          URL du repo GitHub
          <input
            className="input"
            placeholder="https://github.com/owner/repo"
            value={repoUrl}
            onChange={(e) => setRepoUrl(e.target.value)}
            required
          />
        </label>
        <label>
          Branche
          <input className="input" value={branch} onChange={(e) => setBranch(e.target.value)} />
        </label>
        <button className="btn btn--primary" type="submit" disabled={loading}>
          Analyser le repo
        </button>
      </form>

      {error && <p className="error">{error}</p>}

      {candidates && (
        <form onSubmit={handleConfirm} className="form">
          <fieldset>
            <legend>Fichier de projet (.json) à référencer</legend>
            {candidates.length === 0 && <p>Aucun fichier .json trouvé dans ce repo.</p>}
            {candidates.map((c) => (
              <label key={c.path} className="radio-row">
                <input
                  type="radio"
                  name="jsonPath"
                  checked={selectedPath === c.path}
                  onChange={() => setSelectedPath(c.path)}
                />
                <code>{c.path}</code>
                {c.looksLikeProject && <span className="badge badge--ok">projet Shoggoth probable</span>}
                {c.looksLikeTranslation && <span className="badge">overlay de traduction probable</span>}
              </label>
            ))}
          </fieldset>

          <label>
            Nom affiché
            <input className="input" value={name} onChange={(e) => setName(e.target.value)} required />
          </label>
          <label>
            Description (optionnel)
            <textarea className="input" value={description} onChange={(e) => setDescription(e.target.value)} />
          </label>

          <button className="btn btn--primary" type="submit" disabled={!selectedPath || loading}>
            Ajouter ce projet
          </button>
        </form>
      )}
    </div>
  );
}
